import { configureStore } from '@reduxjs/toolkit';
import { combineEpics, createEpicMiddleware } from 'redux-observable';
import { catchError } from 'rxjs/operators';

// SLICES
import processCardInfoSlice from '../containers/processCardInfo/processCardInfoSlice';

// EPICS
import processCardInfoEpics from '../containers/processCardInfo/processCardInfoEpics';

const epicMiddleware = createEpicMiddleware();
const epics = combineEpics(...processCardInfoEpics);

const rootEpic = (action$, store$, dependencies) =>
	epics(action$, store$, dependencies).pipe(
		catchError((error, source) => {
			console.error(error);
			return source;
		})
	);

export const store = configureStore({
	reducer: {
		processCardInfoSlice
	},
	middleware: [epicMiddleware]
});

epicMiddleware.run(rootEpic);
